import React from 'react';
import Icon from '../../../components/AppIcon';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const ComplianceTrendsChart = ({ data }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Compliance Status Trends</h3>
          <p className="text-sm text-muted-foreground">
            6-month historical view of compliance performance
          </p>
        </div>
        <Icon name="TrendingUp" size={20} color="var(--color-muted-foreground)" />
      </div>

      <div className="h-80">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line
              type="monotone"
              dataKey="compliant"
              stroke="#10b981"
              strokeWidth={2}
              name="Compliant"
            />
            <Line
              type="monotone"
              dataKey="atRisk"
              stroke="#f59e0b"
              strokeWidth={2}
              name="At Risk"
            />
            <Line
              type="monotone"
              dataKey="overdue"
              stroke="#ef4444"
              strokeWidth={2}
              name="Overdue"
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-border">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-3 h-3 rounded-full bg-success" />
            <span className="text-sm font-medium text-muted-foreground">Compliant</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.[data?.length - 1]?.compliant}</p>
          <p className="text-xs text-muted-foreground mt-1">Current month</p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-3 h-3 rounded-full bg-orange-500" />
            <span className="text-sm font-medium text-muted-foreground">At Risk</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.[data?.length - 1]?.atRisk}</p>
          <p className="text-xs text-muted-foreground mt-1">Needs attention</p>
        </div>
        <div className="text-center">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-3 h-3 rounded-full bg-destructive" />
            <span className="text-sm font-medium text-muted-foreground">Overdue</span>
          </div>
          <p className="text-2xl font-bold text-foreground">{data?.[data?.length - 1]?.overdue}</p>
          <p className="text-xs text-muted-foreground mt-1">Immediate action</p>
        </div>
      </div>
    </div>
  );
};

export default ComplianceTrendsChart;